module.exports = __webpack_public_path__ + "static/media/table-3.edbb9116.webp";